<template>
  <svg @mouseover="openTooltip" @mouseout="closeTooltip" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="size" :height="size" viewBox="0 0 47 47">
    <defs>
      <filter id="Path_3" x="0" y="0" width="47" height="47" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="3" result="blur"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="blur"/>
        <feComposite in="SourceGraphic"/>
      </filter>
    </defs>
    <g id="Component_19_63" data-name="Component 19 – 63" transform="translate(9 6)">
      <g v-if="shadow" transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Path_3)">
        <path id="Path_3-2" data-name="Path 3" d="M14.5,0A14.5,14.5,0,1,1,0,14.5,14.5,14.5,0,0,1,14.5,0Z" transform="translate(9 6)" fill="#fff"/>
      </g>
      <g v-else transform="matrix(1, 0, 0, 1, -9, -6)">
        <path id="Path_3-2" data-name="Path 3" d="M14.5,0A14.5,14.5,0,1,1,0,14.5,14.5,14.5,0,0,1,14.5,0Z" transform="translate(9 6)" fill="#fff"/>
      </g>
      <g id="Ellipse_78" data-name="Ellipse 78" transform="translate(4.247 12.525) rotate(-45)" fill="none" stroke="#004c64" stroke-width="2">
        <circle cx="5.5" cy="5.5" r="5.5" stroke="none"/>
        <circle cx="5.5" cy="5.5" r="4.5" fill="none"/>
      </g>
      <g id="Rectangle_253" data-name="Rectangle 253" transform="translate(13.439 16.061) rotate(-45)" fill="none" stroke="#004c64" stroke-linecap="round" stroke-width="2">
        <rect width="3" height="9" rx="1.5" stroke="none"/>
        <rect x="1" y="1" width="1" height="7" rx="0.5" fill="none"/>
      </g>
    </g>
  </svg>
</template>


<script>
import {EventBus} from '@/event-bus.js'

export default {
  'name': 'developments-to-watch',
  'props': {
    'size': {
      type: Number,
      default: 47
    },
    'shadow': {
      type: Boolean,
      default: true
    }
  },
  destroyed () {
    EventBus.$emit('tooltip.hide')
  },
  methods: {
    openTooltip () {
      EventBus.$emit('tooltip.show', {
        style: 'multiline',
        label: 'Developments to watch',
        value: [
          '<span class="text-sm">' + this.$Strings('covid19_watch_tooltip') + '</span>'
        ]
      })
    },
    closeTooltip () {
      EventBus.$emit('tooltip.hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/DevelopmentsToWatch.vue.vue